import React from "react";
import { Link } from "react-router-dom";
import { useContextUsuario } from '../../contexto/usuario/UsuarioContext'; // Asegúrate de tener el contexto disponible
import ModalBootstrap from "../modal/ModalBootstrap";
import CarritoProductos from "./CarritoProducto";

const ModalCarritoPedidos = ({ modalIsOpen, setModalIsOpen, carritoPedido }) => {
  const { usuario } = useContextUsuario();
  const isEmpleado = usuario?.tipo === "Empleado";

  const rutaPedidos = isEmpleado ? "/app/admin/pedidos/editar" : "/app/clientes/pedidos/nuevo";

  return (
    <ModalBootstrap
      estiloBoton="btn btn-link text-secondary p-0"
      iconBoton="fa-solid fa-cart-shopping text-white"
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
      titulo="Pedidos"
      pie={
        <Link
          to={rutaPedidos}
          className="btn btn-primary mx-2"
          style={{ fontSize: "16px" }}
        >
          {isEmpleado ? "Ver Pedidos Pendientes" : "Guardar mis pedidos"}
        </Link>
      }
    >
      <CarritoProductos carritoPedido={carritoPedido} isEmpleado={isEmpleado} />
    </ModalBootstrap>
  );
};

export default ModalCarritoPedidos;
